/**
 * Canonical payment_method_type values for Mixpanel and analytics.
 * Normalizes Stripe Payment Element, Express Checkout, and elements.submit() shapes.
 */
export type PaymentMethodType =
  | "card"
  | "apple_pay"
  | "google_pay"
  | "link"
  | "us_bank_account"

const CANONICAL_TYPES: Record<string, PaymentMethodType> = {
  card: "card",
  apple_pay: "apple_pay",
  applePay: "apple_pay",
  google_pay: "google_pay",
  googlePay: "google_pay",
  link: "link",
  us_bank_account: "us_bank_account",
}

export function normalizePaymentMethodType(type: unknown): PaymentMethodType {
  if (type == null || type === "") return "card"

  const raw = String(type).trim()
  if (CANONICAL_TYPES[raw]) return CANONICAL_TYPES[raw]

  const snakeCase = raw
    .replace(/([a-z])([A-Z])/g, "$1_$2")
    .replace(/-/g, "_")
    .toLowerCase()

  return CANONICAL_TYPES[snakeCase] ?? "card"
}
